import * as moment from 'moment';

const messages = [
  {
    message: 'Hey David! How\'s it going?',
    when: moment().subtract(35, 'minutes'),
    who: 'partner'
  },
  {
    message: 'You wanted to go golfing you remember? What about this weekend?',
    when: moment().subtract(34, 'minutes'),
    who: 'partner'
  },
  {
    message: 'Hey! I\'m good. Sure, let\'s meet on Saturday at the golf club, okay?',
    when: moment().subtract(28, 'minutes'),
    who: 'me'
  },
  {
    message: 'Sure thing! I hope we can finally beat our record this time. :)',
    when: moment().subtract(26, 'minutes'),
    who: 'partner'
  },
  {
    message: 'Awesome! We surely will. ;)',
    when: moment().subtract(22, 'minutes'),
    who: 'me'
  },
  {
    message: 'See you on Saturday!',
    when: moment().subtract(21, 'minutes'),
    who: 'me'
  }
];

export let chatDemoData = [
  {
    'picture': 'assets/img/demo/avatars/13.png',
    'name': 'Lawrence Larson',
    'messages': messages,
    'lastMessageTime': moment().subtract(170, 'minutes'),
    'lastMessage': 'commodo deserunt enim'
  },
  {
    'picture': 'assets/img/demo/avatars/10.png',
    'name': 'Therese Alvarez',
    'messages': messages,
    'lastMessageTime': moment().subtract(371, 'minutes'),
    'lastMessage': 'sunt duis dolor'
  },
  {
    'picture': 'assets/img/demo/avatars/3.png',
    'name': 'Roseann Dejesus',
    'messages': messages,
    'lastMessageTime': moment().subtract(410, 'minutes'),
    'lastMessage': 'et duis ex'
  },
  {
    'picture': 'assets/img/demo/avatars/15.png',
    'name': 'Lorena Aguirre',
    'messages': messages,
    'lastMessageTime': moment().subtract(239, 'minutes'),
    'lastMessage': 'consectetur dolor ea'
  },
  {
    'picture': 'assets/img/demo/avatars/18.png',
    'name': 'Ayala Martinez',
    'messages': messages,
    'lastMessageTime': moment().subtract(534, 'minutes'),
    'lastMessage': 'velit reprehenderit in'
  },
  {
    'picture': 'assets/img/demo/avatars/10.png',
    'name': 'Helene Curtis',
    'messages': messages,
    'lastMessageTime': moment().subtract(215, 'minutes'),
    'lastMessage': 'enim aute dolore'
  },
  {
    'picture': 'assets/img/demo/avatars/20.png',
    'name': 'Donovan Vega',
    'messages': messages,
    'lastMessageTime': moment().subtract(539, 'minutes'),
    'lastMessage': 'eiusmod aute et'
  },
  {
    'picture': 'assets/img/demo/avatars/4.png',
    'name': 'Frieda Robbins',
    'messages': messages,
    'lastMessageTime': moment().subtract(187, 'minutes'),
    'lastMessage': 'officia excepteur elit'
  },
  {
    'picture': 'assets/img/demo/avatars/20.png',
    'name': 'Dolores Rojas',
    'messages': messages,
    'lastMessageTime': moment().subtract(30, 'minutes'),
    'lastMessage': 'ad duis ex'
  },
  {
    'picture': 'assets/img/demo/avatars/16.png',
    'name': 'Lila Wade',
    'messages': messages,
    'lastMessageTime': moment().subtract(158, 'minutes'),
    'lastMessage': 'in nostrud anim'
  },
  {
    'picture': 'assets/img/demo/avatars/19.png',
    'name': 'Toni Knapp',
    'messages': messages,
    'lastMessageTime': moment().subtract(288, 'minutes'),
    'lastMessage': 'consectetur id tempor'
  }
];
